import actions from '@/core/store/penalidades/dados-gerais/actions'
import state from '@/core/store/penalidades/dados-gerais/state'

export default {
	actions,
	state,
}
